module.exports = "/_next/static/images/winner-bg-50fe645e7991de3e4e846ee741932056.png";